import React from 'react';
import { Wallet, LogOut, User } from 'lucide-react';
import { useWeb3 } from '../hooks/useWeb3';

export const WalletConnect: React.FC = () => {
  const { account, isConnected, isConnecting, error, connectWallet, disconnectWallet } = useWeb3();

  const formatAddress = (address: string) => {
    return `${address.slice(0, 6)}...${address.slice(-4)}`;
  };

  return (
    <div className="flex items-center gap-4">
      {!isConnected ? (
        <button
          onClick={connectWallet}
          disabled={isConnecting}
          className="flex items-center gap-2 px-4 py-2 bg-purple-400/20 border border-purple-400/30 rounded-lg text-purple-400 hover:bg-purple-400/30 disabled:opacity-50 disabled:cursor-not-allowed transition-colors shrine-button"
        >
          <Wallet className="w-5 h-5" />
          {isConnecting ? 'Connecting...' : 'Connect Wallet'}
        </button>
      ) : (
        <div className="flex items-center gap-3">
          <div className="flex items-center gap-2 px-4 py-2 bg-green-400/20 border border-green-400/30 rounded-lg text-green-400">
            <User className="w-5 h-5" />
            <span className="font-mono text-sm">{formatAddress(account!)}</span>
          </div>
          <button
            onClick={disconnectWallet}
            className="p-2 bg-zinc-700/50 border border-zinc-600 rounded-lg text-zinc-400 hover:bg-zinc-700/70 transition-colors"
            title="Disconnect Wallet"
          >
            <LogOut className="w-5 h-5" />
          </button>
        </div>
      )}

      {error && (
        <div className="text-red-400 text-sm">
          {error}
        </div>
      )}
    </div>
  );
};
